export default "__VITE_ASSET__eba97c8d__"